import React from "react";
import { UserCheck, Star, AlertCircle, Users, ShieldCheck } from "lucide-react";

// Badge pills carry their own opaque background and dark text, so they stay
// legible (8.1-11.9:1) on both the light cards and the dark sections they are
// also rendered on. The previous `bg-*/15` + `text-*-400` pairing only worked
// on dark pages and measured 1.5-2.5:1 on white.
const BADGE_CONFIG = {
  new_player:     { icon: Users,      bg: "bg-slate-200",  text: "text-slate-800",  border: "border-slate-300" },
  reliable:       { icon: UserCheck,  bg: "bg-blue-200",   text: "text-blue-900",   border: "border-blue-300" },
  highly_reliable:{ icon: Star,       bg: "bg-green-200",  text: "text-green-900",  border: "border-green-300" },
  needs_history:  { icon: AlertCircle,bg: "bg-amber-200",  text: "text-amber-900",  border: "border-amber-300" },
};

export function VerifiedPartnerBadge({ size = "sm" }) {
  const iconSize = size === "xs" ? 10 : 11;
  const px = size === "xs" ? "px-1.5 py-0.5" : "px-2 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1 ${px} rounded-full border bg-brand-green/10 text-brand-green border-brand-green/30 text-xs font-semibold whitespace-nowrap`}
      data-testid="verified-partner-badge"
      title="Verified Partner — 10+ sessions, 90%+ reliability"
      aria-label="Verified Partner"
    >
      <ShieldCheck size={iconSize} aria-hidden="true" />
      Verified
    </span>
  );
}

export default function ReliabilityBadge({ badge, label, size = "sm", showIcon = true }) {
  const key = badge || "new_player";
  const cfg = BADGE_CONFIG[key] || BADGE_CONFIG.new_player;
  const Icon = cfg.icon;
  const textSize = "text-xs";
  const iconSize = size === "xs" ? 10 : 11;
  const px = size === "xs" ? "px-1.5 py-0.5" : "px-2 py-0.5";

  return (
    <span
      className={`inline-flex items-center gap-1 ${px} rounded-full border ${cfg.bg} ${cfg.text} ${cfg.border} ${textSize} font-medium whitespace-nowrap`}
      data-testid="reliability-badge"
      title={`Reliability: ${label}`}
    >
      {showIcon && <Icon size={iconSize} aria-hidden="true" />}
      {label || "New Player"}
    </span>
  );
}
